module.exports = __webpack_public_path__ + "img/img11.df4d013e.png";